// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-comment-card {
  font-family: Roboto;
  display: flex;
  width: 653px;
  height: 104px;
  padding: 10px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  .product-title {
    font-family: Roboto;
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 19px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .product-comments {
    color: var(--Colors-Text-400, #3b3f3d);
    font-size: var(--Font-Font-Size-p, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.comments-close-btn,
.comments-close-btn:hover {
  width: 126px;
  height: 44px;
  padding: 8px 20px;
  display: flex;
  justify-content: center;
  background: #d2042d !important;
  color: #fff;
  gap: 8px;
  flex-shrink: 0;
  margin: auto;
  font-size: 16px;
}

.comments-close-btn:hover {
  color: "#fff" !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/modals/offer-comments-modal/OfferCommentsModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;;EAEd;IACE,mBAAmB;IACnB,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".offer-comment-card {\n  font-family: Roboto;\n  display: flex;\n  width: 653px;\n  height: 104px;\n  padding: 10px 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n\n  .product-title {\n    font-family: Roboto;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 19px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .product-comments {\n    color: var(--Colors-Text-400, #3b3f3d);\n    font-size: var(--Font-Font-Size-p, 16px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.comments-close-btn,\n.comments-close-btn:hover {\n  width: 126px;\n  height: 44px;\n  padding: 8px 20px;\n  display: flex;\n  justify-content: center;\n  background: #d2042d !important;\n  color: #fff;\n  gap: 8px;\n  flex-shrink: 0;\n  margin: auto;\n  font-size: 16px;\n}\n\n.comments-close-btn:hover {\n  color: \"#fff\" !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
